import { Box, Typography, Card, CardContent, Stack, alpha, useTheme, Chip } from '@mui/material';

const DECOR_COLORS = ['#CE93D8', '#80CBC4', '#FFD54F', '#66BB6A'];

export default function About() {
  const theme = useTheme();

  return (
    <Box sx={{ p: 2, maxWidth: 720, mx: 'auto' }}>
      {/* Decorative hero section */}
      <Box
        sx={{
          position: 'relative',
          overflow: 'hidden',
          borderRadius: 4,
          p: 4,
          mb: 3,
          textAlign: 'center',
          background: theme.palette.mode === 'dark'
            ? `linear-gradient(135deg, ${alpha(theme.palette.primary.dark, 0.3)}, ${alpha(theme.palette.secondary.dark, 0.2)})`
            : `linear-gradient(135deg, ${alpha(theme.palette.primary.light, 0.4)}, ${alpha(theme.palette.secondary.light, 0.3)})`,
        }}
      >
        {/* Floating decorative dots */}
        {DECOR_COLORS.map((color, i) => (
          <Box
            key={i}
            sx={{
              position: 'absolute',
              width: i === 0 ? 120 : 60 + i * 20,
              height: i === 0 ? 120 : 60 + i * 20,
              borderRadius: '50%',
              background: `radial-gradient(circle, ${alpha(color, 0.4)} 0%, transparent 70%)`,
              top: -20 + (i % 3) * 60,
              left: -10 + (i % 4) * 80,
              animation: `floatAround ${6 + i * 2}s ease-in-out infinite`,
              animationDelay: `${i * 0.8}s`,
            }}
          />
        ))}

        <Box
          sx={{
            width: 72, height: 72, borderRadius: '50%',
            background: `linear-gradient(135deg, ${theme.palette.primary.main}, ${theme.palette.secondary.main})`,
            mx: 'auto', mb: 2,
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            boxShadow: `0 8px 32px ${alpha(theme.palette.primary.main, 0.35)}`,
            position: 'relative', zIndex: 1,
          }}
        >
          <Typography variant="h3" sx={{ fontWeight: 800, color: '#fff', lineHeight: 1 }}>
            H
          </Typography>
        </Box>

        <Typography variant="h4" sx={{ fontWeight: 800, mb: 1, position: 'relative', zIndex: 1 }}>
          HodQuiz Helper
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ position: 'relative', zIndex: 1 }}>
          智能刷题助手
        </Typography>
      </Box>

      {/* Info cards */}
      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>开发者信息</Typography>
          <Stack spacing={1}>
            <InfoRow label="开发者" value="云云" />
            <InfoRow label="英文名" value="DirRain" />
            <InfoRow label="工作室" value="禾云工作室" />
            <InfoRow label="英文名" value="HoCloud Technology Studio" />
          </Stack>
        </CardContent>
      </Card>

      <Card sx={{ mb: 2 }}>
        <CardContent>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>功能特性</Typography>
          <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.8 }}>
            {['.hqb 格式题库上传', '快速开始刷题', '自定义刷题数量', '题目乱序 / 选项乱序', '全局搜索搜题', '自动下一题', '答题结果统计', '题库管理'].map(f => (
              <Chip key={f} label={f} size="small" variant="outlined" />
            ))}
          </Stack>
        </CardContent>
      </Card>

      <Card>
        <CardContent>
          <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>技术栈</Typography>
          <Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.8 }}>
            {['React 19', 'TypeScript', 'MUI Material Design 9', 'Vite 8', 'React Router 7'].map(tech => (
              <Chip key={tech} label={tech} size="small" variant="outlined" />
            ))}
          </Stack>
        </CardContent>
      </Card>

      <style>{`
        @keyframes floatAround {
          0%, 100% { transform: translate(0, 0) scale(1); }
          25% { transform: translate(10px, -10px) scale(1.05); }
          50% { transform: translate(-5px, 8px) scale(0.95); }
          75% { transform: translate(-8px, -5px) scale(1.02); }
        }
      `}</style>
    </Box>
  );
}

function InfoRow({ label, value }: { label: string; value: string }) {
  return (
    <Stack direction="row" spacing={2} sx={{ alignItems: 'center' }}>
      <Typography variant="body2" color="text.secondary" sx={{ minWidth: 100 }}>{label}</Typography>
      <Typography variant="body2" sx={{ fontWeight: 500 }}>{value}</Typography>
    </Stack>
  );
}
